<p>Dev Ticket Completion</p>
<form (ngSubmit)="onCompleteTicket()" [formGroup]="completionForm">
  <mat-form-field>
    <mat-label>Completion Code</mat-label>
    <input formControlName="completionCode" matInput required type="text">
    @if (completionForm.controls['completionCode']) {
      <mat-error>Please enter completion code</mat-error>
    }
  </mat-form-field>

  <mat-form-field>
    <mat-label>Follow On Note</mat-label>
    <input formControlName="followOnNote" matInput type="text">
  </mat-form-field>

  <mat-checkbox color="primary" formControlName="followOnRequired">
    Follow On Required
  </mat-checkbox>

  <mat-dialog-actions>
    <button mat-dialog-close="" mat-flat-button type="reset" [disabled]="submitting">{{ 'scheduler.general.cancel' | translate }}</button>
    <button color="primary" mat-raised-button type="submit" [disabled]="submitting">
      @if (submitting) {
        Completing...
      } @else {
        Save
      }
    </button>
  </mat-dialog-actions>

</form>
